/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCropDtoCollectionResponseFromDiscriminatorValue, type CropDtoCollectionResponse } from '../../../models/index.js';
// @ts-ignore
import { createODataErrorFromDiscriminatorValue, type ODataError } from '../../../models/oDataErrors/index.js';
// @ts-ignore
import { CountRequestBuilderRequestsMetadata, type CountRequestBuilder } from './count/index.js';
// @ts-ignore
import { type WithCropItemRequestBuilder, WithCropItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Provides operations to manage the crop property of the AapService.GenusDto entity.
 */
export interface CropRequestBuilder extends BaseRequestBuilder<CropRequestBuilder> {
    /**
     * Provides operations to count the resources in the collection.
     */
    get count(): CountRequestBuilder;
    /**
     * Provides operations to manage the crop property of the AapService.GenusDto entity.
     * @param cropId The unique identifier of CropDto
     * @returns {WithCropItemRequestBuilder}
     */
     byCropId(cropId: number) : WithCropItemRequestBuilder;
    /**
     * Get crop from GenusOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CropDtoCollectionResponse>}
     * @throws {ODataError} error when the service returns a 4XX or 5XX status code
     */
     get(requestConfiguration?: RequestConfiguration<CropRequestBuilderGetQueryParameters> | undefined) : Promise<CropDtoCollectionResponse | undefined>;
    /**
     * Get crop from GenusOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CropRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Get crop from GenusOverview
 */
export interface CropRequestBuilderGetQueryParameters {
    /**
     * Include count of items
     */
    count?: boolean;
    /**
     * Expand related entities
     */
    expand?: string[];
    /**
     * Filter items by property values
     */
    filter?: string;
    /**
     * Order items by property values
     */
    orderby?: string[];
    /**
     * Search items by search phrases
     */
    search?: string;
    /**
     * Select properties to be returned
     */
    select?: string[];
    /**
     * Skip the first n items
     */
    skip?: number;
    /**
     * Show only the first n items
     */
    top?: number;
}
/**
 * Uri template for the request builder.
 */
export const CropRequestBuilderUriTemplate = "{+baseurl}/GenusOverview/{genusId}/crop{?%24count,%24expand,%24filter,%24orderby,%24search,%24select,%24skip,%24top}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const CropRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "count": "%24count",
    "expand": "%24expand",
    "filter": "%24filter",
    "orderby": "%24orderby",
    "search": "%24search",
    "select": "%24select",
    "skip": "%24skip",
    "top": "%24top",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CropRequestBuilderNavigationMetadata: Record<Exclude<keyof CropRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCropId: {
        requestsMetadata: WithCropItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["cropId"],
    },
    count: {
        requestsMetadata: CountRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CropRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CropRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            XXX: createODataErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCropDtoCollectionResponseFromDiscriminatorValue,
        queryParametersMapper: CropRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
